import { aggregateKpiMetricValue } from './service/kpi-metric/aggregate-kpi-metric'
import { aggregateKpiValue } from './service/kpi/aggregate-kpi'

process.on('bootstrap-module-global-public-route' as any, (app, globalPublicRouter) => {
  /*
   * can add global public routes to application (auth not required, tenancy not required)
   *
   * ex) routes.get('/path', async(context, next) => {})
   * ex) routes.post('/path', async(context, next) => {})
   */

  // KPI-Metric 스케줄러 콜백 엔드포인트
  globalPublicRouter.post('/callback-schedule-for-kpi-metric', async (context, next) => {
    const { client } = context.request.body

    if (!client || typeof client !== 'object') {
      throw new Error('client property should be a part of callback body.')
    }

    const { group: domainId, key: metricId } = client

    if (!domainId || !metricId) {
      throw new Error(`group(${domainId}) and key(${metricId}) properties should not be empty`)
    }

    try {
      // KPI-Metric 집계/자동화 함수 호출
      const values = await aggregateKpiMetricValue(metricId, domainId, context)
      console.log(`[KPI-Metric Schedule Callback] domainId=${domainId}, metricId=${metricId}, values=`, values)
      context.status = 200
    } catch (err) {
      console.error('[KPI-Metric Schedule Callback][ERROR]', err)
      context.status = 500
      context.body = { error: err.message || String(err) }
    }
  })

  // KPI 스케줄러 콜백 엔드포인트
  globalPublicRouter.post('/callback-schedule-for-kpi', async (context, next) => {
    const { client } = context.request.body

    if (!client || typeof client !== 'object') {
      throw new Error('client property should be a part of callback body.')
    }

    const { group: domainId, key: kpiId } = client

    if (!domainId || !kpiId) {
      throw new Error(`group(${domainId}) and key(${kpiId}) properties should not be empty`)
    }

    try {
      // KPI 집계/자동화 함수 호출
      const values = await aggregateKpiValue(kpiId, domainId, context)
      console.log(`[KPI Schedule Callback] domainId=${domainId}, kpiId=${kpiId}, values=`, values)
      context.status = 200
    } catch (err) {
      console.error('[KPI Schedule Callback][ERROR]', err)
      context.status = 500
      context.body = { error: err.message || String(err) }
    }
  })
})

process.on('bootstrap-module-global-private-route' as any, (app, globalPrivateRouter) => {
  /*
   * can add global private routes to application (auth required, tenancy not required)
   */
})

process.on('bootstrap-module-domain-public-route' as any, (app, domainPublicRouter) => {
  /*
   * can add domain public routes to application (auth not required, tenancy required)
   */
})

process.on('bootstrap-module-domain-private-route' as any, (app, domainPrivateRouter) => {
  /*
   * can add domain private routes to application (auth required, tenancy required)
   */
})
